var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-flow-error--outer-container gds-flex-container" },
    [
      _c("div", { staticClass: "global-flow-error--inner-container" }, [
        !_vm.img
          ? _c("img", {
              staticClass: "maintenance-graphic",
              attrs: {
                src:
                  "/wp-content/themes/gmptwentynineteen/assets/images/maintenance-error.svg"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.img
          ? _c("img", {
              staticClass: "maintenance-graphic",
              attrs: { src: _vm.img }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "maintenance-message maintenance-message--main gds-space-stack-m"
          },
          [
            _vm._v("\n      " + _vm._s(_vm.name) + "\n      "),
            _vm.state === "maintenance"
              ? [
                  _vm._v(
                    "is temporarily disabled while we perform routine maintenance. Please try again later."
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.state === "error"
              ? [
                  _vm._v("\n        is not available at the moment.\n        "),
                  _c("br"),
                  _vm._v("Please try again later.\n      ")
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.state === "unavailable"
              ? [_vm._v("is not available for this account.")]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.phonetext
          ? _c(
              "div",
              { staticClass: "maintenance-message--phone gds-space-stack-l" },
              [
                _vm._v("\n      " + _vm._s(_vm.phonetext) + "\n      "),
                _c("span", { staticClass: "gds-nobreak" }, [
                  _vm._v(_vm._s(_vm.GMPPhoneNumber) + ".")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.closepath
          ? _c(
              "button",
              {
                staticClass: "global-flow-error__button gds-button",
                on: {
                  click: function($event) {
                    return _vm.ReturnToSender(_vm.closepath)
                  }
                }
              },
              [_vm._v("Close")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }